export default __webpack_public_path__ + "static/media/cadentLogo.357d2f42.svg";